// BHP-1079: real sidebar figures via Backend2.0 (Hydra collections) — no legacy
// /api/v1 calls.
//
// - Domains: authoritative — domains are persisted, so the /api/domains
//   collection count is real (from totalItems).
// - Servers: authoritative since BHP-1121. The Vps table became a projection of
//   what actually runs at Hetzner with the reconcile sync (BHP-1067), and the
//   collection filters out soft-deleted rows, so totalItems is the real number.
//   Before that it was left blank on purpose, because a count off that table
//   would have been wrong.
// - This month: left blank ("–"). The Backend2.0 InvoiceOutputDto has no total
//   amount yet, and the exact meaning needs a product decision.
//
// Scoping note: both counts are per active customer — the collections are scoped
// by CustomerScopeExtension and httpClient sends `x-active-customer` (BHP-1081),
// so switching customer changes these figures.
//
// A dash means "we do not know yet"; a zero is a fact and is shown as 0.
import { useCollection } from '../api/useHydra';

function Stat({
  label,
  value
}: {
  label: string;
  value: string | number | undefined;
}): JSX.Element {
  return (
    <div>
      <div className="text-ink-muted">{label}</div>
      <div className="font-semibold">{value ?? '–'}</div>
    </div>
  );
}

export default function SidebarStats(): JSX.Element {
  const domains = useCollection<Record<string, unknown>>('domains');
  const servers = useCollection<Record<string, unknown>>('vps');

  return (
    <div className="flex gap-3 text-xs">
      <Stat label="Domains" value={domains.data?.total} />
      <Stat label="Servers" value={servers.data?.total} />
      <Stat label="This month" value={undefined} />
    </div>
  );
}
